<div class="main-content">
  Diamond Tier
  <span class="text-info"> (at time of purchase)</span>
</div>
<br />
@if (data !== undefined) {
  <div class="info-container" [style.backgroundColor]="data.backgroundColor1" [style.color]="data.textColor">
    <div class="content-center"><img [src]="imageSrc" /></div>
    <div class="panel-adjust">
      @if (loading) {
        <div class="loading">
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
      }
      <div class="content-left">
        <table>
          @for (field of getFields(); track field) {
            <tr>
              @if (!field.formFullWidth) {
                <td class="field-info">{{ field.label }}</td>
              }
              <td class="field-form" [attr.colspan]="field.formFullWidth ? 2 : 1">
                <app-form-field
                  [type]="field.type"
                  [data]="formGroupSubset.getRawValue()[field.name]"
                  [fieldConfig]="field"
                  [(editMode)]="editMode"
                  [formGroup]="formGroupSubset"></app-form-field>
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
  </div>
}
